import React from 'react';
// import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import UIFilterBar from '../../../UIFilterBar';
import PageSectionHeading from '../../../PageSectionHeading';
import SearchBarBtns from './SearchBarBtns';

const styles = css`
  margin: 30px 0;
  @media(min-width: 992px) {
    margin: 90px 0;
  }
  .TabMenu {
    margin: 0 0 30px 0;
    text-align: center;
    @media (min-width: 992px) {
      margin: 0 0 30px 0;
    }
  }
`;

const filterOptions = {
  communities: [
    {
      type: 'MultiSelect',
      filter: 'AreaMetro',
      title: 'Area',
      placeholder: 'All Areas',
    },
    {
      type: 'MultiSelect',
      filter: 'AreaSubMetro',
      title: 'City',
      placeholder: 'All Cities',
    },
    {
      type: 'MultiSelect',
      filter: 'Price',
      title: 'Price Range',
    },
  ],
  homes: [
    {
      type: 'MultiSelect',
      filter: 'AreaMetro',
      title: 'Area',
      placeholder: 'All Areas',
    },
    {
      type: 'MultiSelect',
      filter: 'AreaSubMetro',
      title: 'City',
      placeholder: 'All Cities',
    },
    {
      type: 'MultiSelect',
      filter: 'Price',
      title: 'Price Range',
    },
    {
      type: 'MultiSelect',
      filter: 'Beds',
      title: 'Beds',
    },
  ],
  plans: [
    {
      type: 'MultiSelect',
      filter: 'AreaMetro',
      title: 'Area',
      placeholder: 'All Areas',
    },
    {
      type: 'MultiSelect',
      filter: 'AreaSubMetro',
      title: 'City',
      placeholder: 'All Cities',
    },
    {
      type: 'MultiSelect',
      filter: 'Price',
      title: 'Price Range',
    },
    {
      type: 'MultiSelect',
      filter: 'Beds',
      title: 'Beds',
    },
  ],
};

class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'communities',
    };
  }
  switchTabHandler = tab => {
    this.setState({
      tab,
    });
  }
  render() {
    const { tab } = this.state;
    return (
      <div className={styles}>
        <PageSectionHeading h3="Quick Search" />
        <div className="TabMenu">
          <button
            onClick={() => this.switchTabHandler('communities')}
            tabIndex={0}
            className={`tab ${tab === 'communities' ? 'active' : ''}`}
          >
            Communities
          </button>
          <button
            onClick={() => this.switchTabHandler('homes')}
            tabIndex={0}
            className={`tab ${tab === 'homes' ? 'active' : ''}`}
          >
            Available Homes
          </button>
          <button
            onClick={() => this.switchTabHandler('plans')}
            tabIndex={0}
            className={`tab ${tab === 'plans' ? 'active' : ''}`}
          >
            Floor Plans
          </button>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <UIFilterBar
                type={tab}
                filterOptions={filterOptions[tab]}
              />
            </div>
            <div className="col-lg-3 pl-lg-0">
              <SearchBarBtns
                tab={tab}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SearchBar.propTypes = {
};

export default (SearchBar);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/QuickSearch/QuickSearch.section.js